import type { SxStyle } from '@aibees/shared/theme';

export const chip: SxStyle = {
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.primary[500],
  background: (p) => p.palette.primary[50],
  borderRadius: (p) => p.spacing(1.5),
  color: (p) => p.palette.primary[500],

  mr: (p) => p.spacing(1),
};

export const deleteIcon: SxStyle = {
  color: (p) => p.palette.primary[500],
};
